// API Base URL Configuration
// Use empty string for production (relative URLs) or localhost for development
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL !== undefined
  ? import.meta.env.VITE_API_BASE_URL
  : 'http://localhost:3000';
